module.exports = __webpack_public_path__ + "img/bells.8d10d14f.png";